import { Component, OnInit } from '@angular/core';
import { SurveyService } from '../../service/survey.service';

@Component({
  selector: 'app-survey-filter',
  templateUrl: './survey-filter.component.html',
  styleUrls: ['./survey-filter.component.scss']
})
export class SurveyFilterComponent implements OnInit {
  public filters:any = null;

  constructor(public surveyService: SurveyService) { }

  ngOnInit(): void {
    this.filters = this.initFiltersObj();
  }

  onFilterChange(i: number) {
    let filterName = this.filters[i].name;
    let filterValue = this.filters[i].selected;
    console.log(`Filter name is ${filterName} and value is ${filterValue}`);
  }

  initFiltersObj() {
    return [
      {name:'LOI',options:[{key:'15 - 20 min',value:'1'}],selected:null},
      {name:'CPI',options:[{key:'100 - 150 min',value:'1'}],selected:null},
      {name:'City',options:[{key:'All',value:'all'}],selected:null},
      {name:'Age',options:[{key:'All',value:'all'}],selected:null},
      {name:'Gender',options:[{key:'Both',value:'both'}],selected:null},
      {name:'Country',options:[{key:'All',value:'all'}],selected:null}
    ]
  }
}
